import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from './App'
import { ThemeProvider } from './theme/ThemeContext'
import { AuthProvider } from './contexts/AuthContext'
import { TimerProvider } from './contexts/TimerContext'
import TimerFloating from './components/timer/TimerFloating'
import DialogHost from './components/ui/DialogHost'
import { initSentry, SentryErrorBoundary } from './lib/sentry'
import ErrorFallback from './components/ErrorFallback'
import './i18n'
import './index.css'

const rootElement = document.getElementById('root')
if (!rootElement) throw new Error('No #root element in index.html')

initSentry()

ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <SentryErrorBoundary fallback={<ErrorFallback />} showDialog={false}>
      <ThemeProvider>
        <BrowserRouter>
          <AuthProvider>
            <TimerProvider>
              <App />
              <TimerFloating />
              {/* Host de confirmaciones y avisos (sustituye a confirm/alert
                  nativos). Va el último para quedar por encima del resto. */}
              <DialogHost />
            </TimerProvider>
          </AuthProvider>
        </BrowserRouter>
      </ThemeProvider>
    </SentryErrorBoundary>
  </React.StrictMode>
)
